module.exports = require('./lib/type');



/*****************
 ** WEBPACK FOOTER
 ** ./~/chai/~/deep-eql/~/type-detect/index.js
 ** module id = 27
 ** module chunks = 1
 **/